import type { CustomDataMap } from "owa-analytics-types";

export function flattenData(data: any, output: any = {}, check: any = new Set()): CustomDataMap {
    for (const [key, value] of Object.entries(data)) {
        if (typeof value == "object" && value !== null && !check.has(key)) {
            check.add(key);
            flattenData(value, output, check);
        }
        else {
            check.add(key);
            output[key] = value;
        }
    }
    return output;
}
